import React from 'react'

export const SplitContext = React.createContext<{
  isSplitTreatmentOn: (splitName: string) => boolean
}>({ isSplitTreatmentOn: () => false })

export function wrapWithSplitClient(
  WrappedComponent: React.ComponentType,
  rootScope: any
) {
  function isSplitTreatmentOn(splitName: string): boolean {
    if (rootScope.splitClient) {
      return rootScope.splitClient.getTreatment(splitName) === 'on'
    }

    // eslint-disable-next-line no-console
    console.warn(
      'Split client not initialized while retrieving treatment',
      splitName
    )

    return false
  }

  return function withSplitClient(props) {
    return (
      <SplitContext.Provider value={{ isSplitTreatmentOn }}>
        <WrappedComponent {...props} />
      </SplitContext.Provider>
    )
  }
}
